import {AfterViewInit, ChangeDetectionStrategy, Component, computed, DestroyRef, ElementRef, EventEmitter, Injectable, Input, OnDestroy, Output, signal} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {AgendaelementId, AgendaelementModell, GruppeId, GruppeMedlemListeModell, MøteId, OppdaterSakMedOpsjonerSpesifikasjon, SakstypeModell, SakstypeRessursClient, TemaModell, TemaRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatSelectModule} from "@angular/material/select";
import {VelgMedlemKomponent} from "web-ng2/delt/komponenter/velg-medlem/velg-medlem";
import {MatOptionModule} from "@angular/material/core";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {VelgTemaKomponent} from "../velg-tema/velg-tema";
import {Observable} from "rxjs";
import {konsumerTilDestroy} from "felles-ng2/infrastruktur/rxjs/observerbarHjelpere";
import {VarighetMinutterVelgerKomponent} from "web-ng2/delt/komponenter/varighet-minutter-velger/varighet-minutter-velger";
import {durationFraMinutter, durationTilMinutter, skrivZonedDateTimeSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import {erFlerdagsmøte, erMøteAvholdt, lesMøtedato} from "felles-ng2/modell/møteModellHjelpere";
import {VelgDagFraFlerdagsmøteKomponent} from "../velg-dag-fra-flerdagsmøte/velg-dag-fra-flerdagsmøte";
import {KlokkeslettVelgerKomponent} from "web-ng2/delt/komponenter/klokkeslett-velger/klokkeslett-velger";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatStepperModule} from "@angular/material/stepper";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {BeslutningSkjema, BeslutningSkjemaKontroller} from "web-ng2/moduler/sak/komponenter/beslutninger-skjema/beslutninger-skjema";
import {beslutningsforslag, endeligeBeslutninger} from "felles-ng2/modell/beslutningModellHjelpere";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {VelgSakstypeKomponent} from "web-ng2/moduler/sak/komponenter/velg-sakstype/velg-sakstype";
import {NavigasjonforhindretFlashDirektiv} from "web-ng2/delt/direktiver/navigasjonforhindret-flash/navigasjonforhindret-flash";
import {TranslateModule} from "@ngx-translate/core";
import {scrollTilTopp} from "web-ng2/delt/dom/scrollIntoView";
import {Skedulering} from "felles-ng2/støttefunksjoner/timeout";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {sakStarttidspunkt, startklokkeslettSakSomUTC} from "felles-ng2/modell/sakModellHjelpere";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {MatTooltip} from "@angular/material/tooltip";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {InlineSkjemaKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema";
import {InlineSkjemaHandlingerKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema-handlinger/inline-skjema-handlinger";
import {Gruppeoppsett} from "felles-ng2/tjenester/Gruppeoppsett";
import {MatCheckbox} from "@angular/material/checkbox";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {AgendaelementModellDLM, SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {Sakstidspunkter, SakstidspunkterBeregning} from "felles-ng2/tjenester/Sakstidspunkter";
import {Temporal} from "temporal-polyfill";
import {DataOgMeta, terminerEtterFørsteRequestRespons} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {nil} from "felles-ng2/typer/nullish";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";
import {tomAgendaelementModell} from "felles-ng2/modell/tommeModeller";
import PlainTime = Temporal.PlainTime;
import Duration = Temporal.Duration;

const debug = initDebugger('SakRedigerKontroller');


@Component({
    selector: 'sak-rediger',
    templateUrl: './sak-rediger.html',
    styleUrls: ['./sak-rediger.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatIconModule,
        MatButtonModule,
        MatSlideToggle,
        MatStepperModule,
        MatTooltip,
        MatCheckbox,
        TranslateModule,
        VelgMedlemKomponent,
        VelgTemaKomponent,
        VarighetMinutterVelgerKomponent,
        VelgDagFraFlerdagsmøteKomponent,
        KlokkeslettVelgerKomponent,
        VisSpinnerDirektiv,
        BeslutningSkjemaKontroller,
        VelgSakstypeKomponent,
        NavigasjonforhindretFlashDirektiv,
        StandardValideringsfeilPipe,
        InlineSkjemaKomponent,
        InlineSkjemaHandlingerKomponent,
        RiktekstRedigeringKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakRedigerKontroller implements AfterViewInit, OnDestroy {
    static ajsSelector = 'sakRediger';

    @Output() vedLukk = new EventEmitter<void>();
    @Output() vedGaaTilRedigerReferat = new EventEmitter<number | null>();

    /** Saks-id, mer at vi håndterer ikke endring i angitt id */
    @Input({required: true}) set id(id: AgendaelementId) {
        this.lastSak(id);
    }

    skjema = this.formBuilder.group({
        tittel: ['', FeltValidatorer.litenIkkeTomStreng],
        ansvarlig: [<GruppeMedlemListeModell | null>null],
        varighet: [<Duration | null>null],
        sakstype: [<SakstypeModell | null>null],
        tema: [<TemaModell | null>null],
        beskrivelse: ['', FeltValidatorer.htmlTekst],
        beslutningsforslag: this.formBuilder.array(<BeslutningSkjema[]>[]),
        //kun relevante ved flerdagsmøter
        dag: [<number | null>null],
        startklokkeslett: [<PlainTime | null>null],
        //ikke direkte relatert til sak
        sorterEtterSakstype: new FormControl(false, {nonNullable: true}),
        huskSorterEtterSakstypeValg: new FormControl(false, {nonNullable: true}),
        informerSaksansvarlig: new FormControl(true, {nonNullable: true})
    })

    sak = signal<AgendaelementModellDLM>(tomAgendaelementModell() as AgendaelementModellDLM);
    antallEndeligeBeslutninger = computed(() => endeligeBeslutninger((this.sak() as AgendaelementModell).beslutninger).length); //@todo last fra datalager
    erAvholdt = computed(() => erMøteAvholdt(this.sak().moete, this.klokke));

    gruppemedlemmer = signal<GruppeMedlemListeModell[]>([]); //settes av lastTilleggsdata()
    sakstyper = signal<SakstypeModell[]>([]); //settes av lastTilleggsdata()
    temaer = signal<TemaModell[]>([]); //settes av lastTilleggsdata()
    starttidspunkt!: PlainTime | null;

    lagrer = asynkArbeidPågårSignal();
    initiellSorterEtterSakstypeEndret = false; //bruker signal i NyeSakerSkjemaKontroller, prøver uten signal her for å erfare forskjellen..
    sorterEtterSakstypeTips = ''; //blir init når sakstyper er lastet

    //flerdagsmøte-relatert
    erFlerdagsmoete = computed(() => erFlerdagsmøte(this.sak().moete));
    visStartklokkeslettvelger = false;

    private initiellSorterEtterSakstype = this.skjema.value.sorterEtterSakstype;
    private initialisert = false;

    constructor(private element: ElementRef<HTMLElement>,
                private avhengigheter: SakRedigerKontrollerAvhengigheter,
                private oversettelser: Oversettelser,
                private gjeldendeTidssone: GjeldendeTidssone,
                private klokke: Klokke,
                private sakstidspunkterTjeneste: Sakstidspunkter,
                private navigasjonDeaktivering: NavigasjonDeaktivering,
                private gruppeoppsett: Gruppeoppsett,
                private formBuilder: FormBuilder,
                private destroyRef: DestroyRef) {
        this.navigasjonDeaktivering.deaktiverNavigasjon();
        this.aktiverInformerSaksansvarligVedEndring();
        this.aktiverHuskSorterEtterSakstypeValgVedEndring();
    }

    gaaTilRedigerReferat() {
        this.avbryt();
        this.vedGaaTilRedigerReferat.emit();
    }

    async lagre() {
        await this.lagrer.utfør(async () => {
            const spesifikasjon = this.somSpesifikasjon();
            const sakFlyttetTilAnnenDag = this.sak().dag != spesifikasjon.sak.dag;
            await this.avhengigheter.lagre(this.sak().id, spesifikasjon);
            if (spesifikasjon.huskSorterEtterSakstypeValg)
                this.gruppeoppsett.oppdaterSorterSakerEtterSakstype(this.sak().eiendeGruppeId, spesifikasjon.sorterEtterSakstype);

            this.vedLukk.emit();
            //dersom sak har blitt flyttet til annen dag må hele møtet relastes fordi også andre saker en den vi redigerer har blitt oppdatert
            if (sakFlyttetTilAnnenDag) await this.avhengigheter.relastMøte(this.sak().moete.id);
        })
    }

    avbryt() {
        this.vedLukk.emit();
    }

    ngAfterViewInit() {
        //scroll skjemaet, men med en liten forsinkelse slik at det har rukket å oppta vertikal plass
        new Skedulering(10, 'scroll', this.destroyRef)
          .skeduler(() => scrollTilTopp(this.element.nativeElement));
    }

    ngOnDestroy(): void {
        this.sakstidspunkterBeregning().resetOverstyringer();
        this.navigasjonDeaktivering.reaktiverNavigasjon();
    }


    // private hjelpemetoder

    private lastSak(id: AgendaelementId) {
        this.skjema.disable();
        this.avhengigheter.sak(id)
          .pipe(terminerEtterFørsteRequestRespons())
          .subscribe(sakOgMeta => {
              this.sak.set(sakOgMeta.data);
              this.populerFraSak();
              if (!sakOgMeta.meta.levertFraCache) {
                  this.skjema.enable();
                  this.skjema.controls.informerSaksansvarlig.disable(); //den skal fortsatt være disablet...
              }
          });
    }

    private populerFraSak() {
        this.starttidspunkt = sakStarttidspunkt(this.sak())?.toPlainTime() ?? null;

        //flerdagsmøte-relatert
        if (this.erFlerdagsmoete()) {
            this.skjema.controls.dag.addValidators(Validators.required);
            this.dagEndret(this.sak().dag!); //for at visStartklokkeslettvelger skal settes
        }

        this.oppdaterSkjemaFraSak();

        //populerFraSak kan kalles multiple ganger - sørg for at følgende init kun skjer én gang
        if (!this.initialisert) {
            this.registrerLyttere();
            this.lastTilleggsdata();
            this.initialisert = true;
        }
    }

    /** Dersom bruker endrer dag må starttidspunktvelger vises,
     * med mindre bruker endrer til dag 0 - da bestemmes starttidspunktet av møte.start */
    private dagEndret(valgtDag: number) {
        //startklokkeslett styres av møte.dato.start for dag 0
        if (valgtDag == 0) {
            this.visStartklokkeslettvelger = false;
            return
        }
        //dersom dag ikke er endret - avgjør basert på om sak.starttidspunkt er satt
        if (valgtDag == this.sak().dag)
            this.visStartklokkeslettvelger = erIkkeNil(this.sak().starttidspunkt);
        else
            this.visStartklokkeslettvelger = true; //vi vil alltid vise startklokkeslett-felt dersom bruker endrer til annen dag enn 0

        //propagerer endring av varighet til sakstidspunkter slik at eventuell møte-varighet-overskridelse vises i møte.ts
        this.oppdaterSakstidspunkter(valgtDag, this.starttidspunkt, this.skjema.value.varighet)
    }

    private startklokkeslettEndret(valgtKlokkeslett: PlainTime | null) {
        this.starttidspunkt = valgtKlokkeslett;
        //propagerer endring av varighet til sakstidspunkter slik at eventuell møte-varighet-overskridelse vises i møte.ts
        this.oppdaterSakstidspunkter(this.skjema.value.dag!, valgtKlokkeslett, this.skjema.value.varighet)
    }

    private varighetEndret(valgtVarighet: Duration | null) {
        //propagerer endring av varighet til sakstidspunkter slik at eventuell møte-varighet-overskridelse vises i møte.ts
        this.oppdaterSakstidspunkter(this.skjema.value.dag!, this.starttidspunkt, valgtVarighet)
    }

    private oppdaterSakstidspunkter(dag: number | nil, starttidspunkt: PlainTime | nil, valgtVarighet: Duration | nil) {
        const overstyring = {...this.sak(), varighet: durationTilMinutter(valgtVarighet), dag: dag ?? null};
        if (this.erFlerdagsmoete()) {
            if (erNil(dag) || erNil(starttidspunkt)) return;
            overstyring.starttidspunkt = skrivZonedDateTimeSerialisertOpt(lesMøtedato(this.sak().moete).start.add({days: dag})
              .withTimeZone(this.gjeldendeTidssone.brukersTidssone().somZoneId())
              .withPlainTime(starttidspunkt));
        }
        //ikke gitt at sakstidspunkter har blitt satt når denne metoden kalles første gang (kalles første gang som følge av at 'set id' kalles)
        this.sakstidspunkterBeregning().medOverstyringForSak(overstyring);
    }

    private sakstidspunkterBeregning(): SakstidspunkterBeregning {
        return this.sakstidspunkterTjeneste.forMøte(this.sak().moete.id);
    }

    private oppdaterSkjemaFraSak() {
        this.skjema.patchValue({
            tittel: this.sak().tittel,
            ansvarlig: this.sak().ansvarlig,
            varighet: durationFraMinutter(this.sak().varighet),
            sakstype: this.sak().sakstype,
            tema: this.sak().tema,
            beskrivelse: this.sak().beskrivelse,
            //beslutningsforslag: [] - denne strukturen blir satt lenger ned

            //flerdagsmøte-relatert
            dag: this.sak().dag,
            startklokkeslett: sakStarttidspunkt(this.sak())?.withTimeZone(this.gjeldendeTidssone.brukersTidssone().somZoneId()).toPlainTime() ?? null
        });

        //legg til skjemarader for eksisterende beslutningsforslag
        this.skjema.setControl('beslutningsforslag', BeslutningSkjemaKontroller.opprettSkjemaMedRader(beslutningsforslag((this.sak() as AgendaelementModell).beslutninger))); //@todo last fra datalager

        //les relevant gruppeoppsett valg
        this.initiellSorterEtterSakstype = this.gruppeoppsett.oppsettForGruppe(this.sak().eiendeGruppeId).sorterSakerEtterSakstype;
        this.skjema.controls.sorterEtterSakstype.setValue(this.initiellSorterEtterSakstype);
    }

    private somSpesifikasjon(): OppdaterSakMedOpsjonerSpesifikasjon {
        const skjemaverdier = this.skjema.value;
        return {
            sak: {
                moeteId: this.sak().moete.id,
                tittel: skjemaverdier.tittel!,
                beskrivelse: skjemaverdier.beskrivelse!,
                temaId: skjemaverdier.tema?.id ?? null,
                sakstypeId: skjemaverdier.sakstype?.id ?? null,
                dag: skjemaverdier.dag ?? null,
                //server forventer klokkeslett i UTC
                startklokkeslett: startklokkeslettSakSomUTC(skjemaverdier.startklokkeslett, skjemaverdier.dag, this.sak().moete, this.gjeldendeTidssone.brukersTidssone())?.toJSON() ?? null,
                varighet: erIkkeNil(skjemaverdier.varighet) ? durationTilMinutter(skjemaverdier.varighet) : null,
                ansvarligId: skjemaverdier.ansvarlig?.id ?? null,
                beslutningsforslag: BeslutningSkjemaKontroller.somBeslutningsforslagSpesifikasjoner(this.skjema.controls.beslutningsforslag!)
            },
            informerSaksansvarlig: skjemaverdier.informerSaksansvarlig!,
            sorterEtterSakstype: skjemaverdier.sorterEtterSakstype!,
            huskSorterEtterSakstypeValg: skjemaverdier.huskSorterEtterSakstypeValg!
        };
    }

    private registrerLyttere() {
        this.lytt(this.skjema.controls.varighet.valueChanges, verdi => this.varighetEndret(verdi));
        if (this.erFlerdagsmoete()) {
            this.lytt(this.skjema.controls.dag.valueChanges, verdi => this.dagEndret(verdi!));
            this.lytt(this.skjema.controls.startklokkeslett.valueChanges, verdi => this.startklokkeslettEndret(verdi));
        }
    }

    private lastTilleggsdata() {
        this.lytt(this.avhengigheter.gruppemedlemmer(this.sak().eiendeGruppeId), d => this.gruppemedlemmer.set(d));
        this.lytt(this.avhengigheter.sakstyper(this.sak().eiendeGruppeId), d => this.setSakstyper(d));
        this.lytt(this.avhengigheter.temaer(this.sak().eiendeGruppeId), d => this.temaer.set(d));
    }

    private lytt<T>(observerbar: Observable<T>, vedData: (mottatt: T) => void) {
        konsumerTilDestroy(observerbar, this.destroyRef, vedData);
    }

    private aktiverInformerSaksansvarligVedEndring() {
        this.skjema.controls.informerSaksansvarlig.disable()
        this.skjema.controls.ansvarlig.valueChanges
          .pipe(takeUntilDestroyed())
          .subscribe(() => {
              if (this.skjema.controls.ansvarlig.dirty)
                  this.skjema.controls.informerSaksansvarlig.enable()
              else
                  this.skjema.controls.informerSaksansvarlig.disable()
          });
    }

    private aktiverHuskSorterEtterSakstypeValgVedEndring() {
        this.skjema.controls.sorterEtterSakstype.valueChanges
          .pipe(takeUntilDestroyed())
          .subscribe(sorterEtterSakstype => {
              //dersom sorterEtterSakstype er endret viser vi "husk" checkbox
              this.initiellSorterEtterSakstypeEndret = this.initiellSorterEtterSakstype !== sorterEtterSakstype;
          });
    }

    private setSakstyper(sakstyper: SakstypeModell[]) {
        this.sakstyper.set(sakstyper);
        this.sorterEtterSakstypeTips = this.oversettelser.oversett(i18n('Sorter alle saker etter sakstype ved lagring ({sakstyper}). Se gruppens oppsett for å endre standard rekkefølge.'), {sakstyper: this.sakstyper().map(s => s.navn).join(', ')});
    }
}

@Injectable()
export class SakRedigerKontrollerAvhengigheter {

    constructor(private sakDatatjeneste: SakDatatjeneste,
                private møteDatatjeneste: MøteDatatjeneste,
                private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste,
                private sakstypeRessurs: SakstypeRessursClient,
                private temaRessurs: TemaRessursClient) {
    }

    sak(id: AgendaelementId): Observable<DataOgMeta<AgendaelementModellDLM>> {
        return this.sakDatatjeneste.hentMedMeta(id);
    }

    gruppemedlemmer(gruppeId: GruppeId): Observable<GruppeMedlemListeModell[]> {
        return this.gruppemedlemDatatjeneste.finnTilgjengelige(gruppeId);
    }

    sakstyper(gruppeId: GruppeId): Observable<SakstypeModell[]> {
        return this.sakstypeRessurs.finnAlle(gruppeId).somObservable();
    }

    temaer(gruppeId: GruppeId): Observable<TemaModell[]> {
        return this.temaRessurs.finnAlle(gruppeId).somObservable();
    }

    async lagre(id: AgendaelementId, spesifikasjon: OppdaterSakMedOpsjonerSpesifikasjon): Promise<void> {
        await this.sakDatatjeneste.oppdaterSak(id, spesifikasjon);
    }

    async relastMøte(id: MøteId): Promise<void> {
        await this.møteDatatjeneste.relast(id);
    }
}
